//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants: {
        states: ['Nekompletní', 'Kompletní', 'Vyřešená'],
        types: ['Poškození vlastní vinou', 'Poškození jiného vozidla', 'Poškození jiným vozidlem'],
    },

    methods: {
        occuredDateToTimestamp(value) {
            return dayjs(value, 'YYYY-MM-DD').valueOf();
        },
        getCaseClientName(item) {
            if (!item.case)
                return null;

            this.$refs.master.actualizeRefSkipDirty('cases', item.case, 'clientRef');

            return this.getClientName(item.case.client);
        },
        getClientName(client) {
            this.$refs.master.actualizeRefSkipDirty('clients', client, 'personRef');

            return client && (client.person ? `${client.person.firstName} ${client.person.lastName}` : client.companyName);
        },
        getVehicleName(vehicle) {
            return [vehicle.make, vehicle.model, vehicle.variant].filter(v => v).join(' ');
        },
        getDriverName(driver) {
            return `${driver.firstName} ${driver.lastName}`;
        },
        getOccuredStr(item) {
            return `${$.formatDate(dayjs(item.occuredDate))} ${item.occuredTime || ''}`;
        },
        getCarInsNumber(item) {
            return item.vehicle.carIns.find(r => dayjs(item.occuredDate).isBetween(r.from, r.to))?.number;
        },
        getAccInsNumber(item) {
            return item.vehicle.accIns.find(r => dayjs(item.occuredDate).isBetween(r.from, r.to))?.number;
        },
        getStateXf(value) {
            return value === 2;
        },
        setStateXf(value) {
            return value ? 2 : 1;
        },
        async download(item) {
            const { data } = await axios.get(`/claims/${item.id}/zip`, {
                responseType: 'blob',
            });

            $.downloadBlob(data, `pojistna-udalost_${item.externalId.replace(/ /g, '')}_${item.occuredDate}.zip`);
        },
    },
};
